// extracted by mini-css-extract-plugin
module.exports = {"departments":"kd-z","departmentHeading":"ld-z","departmentSection":"md-z","departmentName":"nd-z","departmentLink":"od-z","expandIcon":"pd-z"};